const SETTINGS = {
  cookieDomain: '.startwillow.com',
  firstTouchMaxAge: 31536000, // 1 year in seconds
  sessionMaxAge: 86400, // 1 day in seconds
  trackingMaxAge: 2592000, // 30 day in seconds
};
const trackingParams = ['gclid', 'twclid'];

function setCookie(name, value, maxAge) {
  document.cookie = `${name}=${value};path=/;max-age=${maxAge};domain=${SETTINGS.cookieDomain};SameSite=Lax`;
}

function getCookies() {
  return document.cookie.split('; ').reduce((acc, cookie) => {
    const [name, value] = cookie.split('=');
    acc[name] = value;
    return acc;
  }, {});
}

function parseUTMParametersFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const utmParams = {};

  for (const [key, value] of params) {
    if (key.startsWith('utm_')) {
      utmParams[key] = value;
    }
  }

  return utmParams;
}

function hasCookiesWithPrefix(prefix) {
  return document.cookie
    .split(';')
    .some((cookie) => cookie.trim().startsWith(prefix));
}

function deleteCookiesWithPrefix(prefix) {
  document.cookie
    .split(';')
    .filter((cookie) => cookie.trim().startsWith(prefix))
    .forEach((cookie) => {
      const name = cookie.split('=')[0].trim();
      setCookie(name, '', 0);
    });
}

function storeFirstTouchUTMs(utmParams) {
  // Only store first touch UTMs if they don't already exist
  if (hasCookiesWithPrefix('ft_utm_')) return;

  for (const [key, value] of Object.entries(utmParams)) {
    setCookie(`ft_${key}`, value, SETTINGS.firstTouchMaxAge);
  }
}

function storeLastTouchUTMs(utmParams) {
  if (Object.keys(utmParams).length === 0) return;

  deleteCookiesWithPrefix('l_utm_');

  for (const [key, value] of Object.entries(utmParams)) {
    setCookie(`l_${key}`, value, SETTINGS.sessionMaxAge);
  }
}

function handleUTMs() {
  const utmParams = parseUTMParametersFromUrl();

  if (Object.keys(utmParams).length === 0) return;

  storeFirstTouchUTMs(utmParams);
  storeLastTouchUTMs(utmParams);
}

function handleTrackingParams() {
  const params = new URLSearchParams(window.location.search);

  trackingParams.forEach((param) => {
    const value = params.get(param);
    if (value) {
      setCookie(`_${param}`, value, SETTINGS.trackingMaxAge);
    }
  });
}

(function () {
  handleUTMs();
  handleTrackingParams();
})();
